var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 42"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 15,
  fill: "#EFA22E"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#202124",
  d: "M21.95 37.241h-1.903c-.083-.018-.163-.047-.246-.053-2.276-.154-4.433-.756-6.428-1.858-4.572-2.525-7.375-6.36-8.362-11.501-.119-.62-.172-1.25-.255-1.876v-1.902c.018-.092.047-.181.053-.276.157-2.267.747-4.421 1.858-6.398C9.66 8.061 14.221 5.166 20.32 4.79c2.918-.18 5.71.445 8.27 1.87 5.346 2.978 8.247 7.55 8.627 13.658.18 2.928-.463 5.723-1.879 8.298-2.519 4.581-6.362 7.379-11.507 8.368-.622.122-1.253.175-1.882.258m-.943-31.204c-8.253-.01-14.956 6.68-14.977 14.941-.02 8.26 6.689 14.983 14.96 14.992 8.252.009 14.955-6.68 14.976-14.941.02-8.26-6.688-14.983-14.959-14.992"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#202124",
  d: "M15.925 13.901c1.114.003 2.038.937 2.024 2.045-.015 1.105-.93 2.012-2.03 2.01-1.114-.004-2.04-.937-2.024-2.045.014-1.106.93-2.013 2.03-2.01M26.09 17.955c-1.112.012-2.042-.915-2.042-2.03 0-1.102.91-2.015 2.012-2.027 1.111-.011 2.042.916 2.042 2.03 0 1.103-.91 2.016-2.012 2.027"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#202124",
  strokeWidth: 2,
  d: "M14.28 25.88h13.44"
})));
export default SvgPoker;